import type { ProjectType } from '../packages/api-client/pm-api';

export function ProjectTypeField({ value, onChange, id = 'project-type', disabled = false }: {
    value: ProjectType; onChange: (value: ProjectType) => void; id?: string; disabled?: boolean;
}) {
    return <div className="form-group">
        <label className="form-label" htmlFor={id}>Project type</label>
        <select disabled={disabled} id={id} className="form-input" value={value} onChange={e => onChange(e.target.value as ProjectType)} aria-describedby={`${id}-help`}>
            <option value="general">General</option>
            <option value="software">Software</option>
        </select>
        <p id={`${id}-help`} className="project-tool-muted">General projects support planning, design, client work, and operations. Software projects also show repositories, code handoffs, and deployment evidence. You can change this later; existing history is kept.</p>
    </div>;
}
